export default __webpack_public_path__ + "static/media/Webstorm-Logo.6cac5400.svg";